<template>
  <b-row class="animated fadeIn">
    <b-col>
      <b-input-group :prepend="prefix">
        <b-form-datepicker v-model="selected_date" />
        <b-button v-if="selected_date" variant="info" @click="clearSelect"
          >Clear</b-button
        >
      </b-input-group>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: "DateFilter",
  props: {
    filter_field: {
      type: String,
      default: null,
    },
    filter_operator: {
      type: String,
      default: null,
    },
    filter_logic: {
      type: String,
      default: null,
    },
    selected: {
      type: String,
      default: null,
    },
    prefix: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selected_date: this.selected,
    };
  },
  methods: {
    clearSelect() {
      this.selected_date = null;
    },
  },
  watch: {
    selected_date() {
      this.$emit("onSelect", {
        field: this.filter_field,
        operator: this.filter_operator,
        value: this.selected_date,
        logic: this.filter_logic,
      });
    },
  },
};
</script>
